import React, { createContext, useContext, useMemo } from 'react';

import { buildSubjectAiPrompt, getSubjectById, getUseCaseById } from './constants/subjectCatalog';

import type { MusicStudioGenerationMode, ScoreContextPayload } from './constants/examAiParams';

import { resolveMusicGenerationMode } from './constants/examAiParams';



export type { MusicStudioGenerationMode };



export interface StudioEditorContextValue {

  subjectId?: string;

  presetId?: string;

  useCaseId?: string;

  subjectLabel?: string;

  useCaseTitle?: string;

  wrapAiPrompt: (userPrompt: string) => string;

  /** Resuelve el camino de generación musical según presencia de repertorio. */

  resolveMusicMode: (scoreContext?: ScoreContextPayload | null) => MusicStudioGenerationMode;

}



const StudioEditorContext = createContext<StudioEditorContextValue | null>(null);



export function StudioEditorProvider({

  subjectId,

  presetId,

  useCaseId,

  children,

}: {

  subjectId?: string;

  presetId?: string;

  useCaseId?: string;

  children: React.ReactNode;

}) {

  const value = useMemo<StudioEditorContextValue>(() => {

    const subject = subjectId ? getSubjectById(subjectId) : undefined;

    const useCase = useCaseId ? getUseCaseById(useCaseId) : undefined;

    return {

      subjectId,

      presetId,

      useCaseId,

      subjectLabel: subject?.name,

      useCaseTitle: useCase?.title,

      wrapAiPrompt: (userPrompt: string) => buildSubjectAiPrompt(subjectId, userPrompt),

      resolveMusicMode: resolveMusicGenerationMode,

    };

  }, [subjectId, presetId, useCaseId]);



  return <StudioEditorContext.Provider value={value}>{children}</StudioEditorContext.Provider>;

}



export function useStudioEditorContext(): StudioEditorContextValue | null {

  return useContext(StudioEditorContext);

}


